import React, { useCallback, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { useDataProvider } from "react-admin";

interface Props {
  onSelect: (value: IParent) => void;
}

const ParentAndPICSearchBox = ({ onSelect }: Props) => {
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState<any[]>([]);

  const { customGetListWithStaticParams } = useDataProvider();

  const getParentsAndPICS = useCallback(async (searchString: string) => {
    try {
      const parentPercentageResponse = await customGetListWithStaticParams(
        `personInCharges?pageSize=50&search=${searchString}`
      );
      const parentsReponse = await customGetListWithStaticParams(
        `parents?pageSize=50&search=${searchString}`
      );

      setOptions([...parentPercentageResponse.data, ...parentsReponse.data]);
    } catch (error) {
      console.log("ERROR", error);
    }
  }, []);

  useEffect(() => {
    getParentsAndPICS(inputValue);
  }, [inputValue, getParentsAndPICS]);

  return (
    <Autocomplete
      id="combo-box-demo"
      options={options}
      getOptionLabel={(option) =>
        `${option.firstName} ${option.lastName} - ${option.user.email} - ${
          option.company ? option.company.name : "Parent"
        }`
      }
      style={{ width: 300 }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={(event, newInputValue) => {
        onSelect(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Type Parent or PIC Name"
          variant="outlined"
        />
      )}
    />
  );
};

export default ParentAndPICSearchBox;
